export const getNumPages = (asset) => {
    var _a, _b, _c, _d, _e;
    if (((_b = (_a = asset.data) === null || _a === void 0 ? void 0 : _a.info) === null || _b === void 0 ? void 0 : _b.image) && 'numPages' in asset.data.info.image) {
        return (_e = (_d = (_c = asset.data) === null || _c === void 0 ? void 0 : _c.info) === null || _d === void 0 ? void 0 : _d.image) === null || _e === void 0 ? void 0 : _e.numPages;
    }
    return 1;
};
/**
 * Determines if the browser is running on an iOS device based on the user agent string
 * @returns boolean
 */
export const isIos = () => typeof navigator !== 'undefined' ? Boolean(navigator.userAgent.match(/iPhone|iPad|iPod/i)) : false;
/**
 * Determines if the browser is running on an Android device based on the user agent string
 * @returns boolean
 */
export const isAndroid = () => typeof navigator !== 'undefined' ? Boolean(navigator.userAgent.match(/android/i)) : false;
/**
 * Determines if the user's primary input method includes a pointing device with limited accuracy (i.e., is touch-based)
 * @returns boolean
 */
export const isCoarsePointer = () => window.matchMedia('(pointer:coarse)').matches;
/**
 * Determines is the user is on a mobile device (iOS, Android, or touch screen)
 * @return boolean
 */
export const isMobile = () => isIos() || isAndroid() || isCoarsePointer();
//# sourceMappingURL=utils.js.map